import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGiftsMaster } from "../../store/giftcards/reducer";
import { REQUEST_DELETE_MASTER_GIFTS } from "../../store/giftcards/giftcardsActionTypes";
interface GiftsDeleteProps {
  event: any;
  isOpen: boolean;
  onClose: () => void;
}

const GiftsDeleteConfirmation: React.FC<GiftsDeleteProps> = ({
  isOpen,
  onClose,
  event,
}) => {
  const dispatch = useDispatch();
  const { masterGifts: events, busy, message } = useGiftsMaster();

  const toast = useToast();

  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === event.key
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "theme is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [event, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Theme</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this theme?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_GIFTS,
                payload: { _id: event.key },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default GiftsDeleteConfirmation;
